/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOrdersKpiFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type OrdersKpi } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/orders/mtd
 */
export interface MtdRequestBuilder extends BaseRequestBuilder<MtdRequestBuilder> {
    /**
     * Counts the active orders the organization took in the period. Despite the route's mtd segment the window is entirely the caller's: nothing is clamped to the current month, and month-to-date is simply what you get by sending the first of the month as the start date. Both bounds are inclusive and are compared against the order date as a full timestamp, so an end date sent without a time stops at midnight. Order status is not considered; only orders marked inactive drop out. A period with no orders is a success reporting zero.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrdersKpi>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<MtdRequestBuilderGetQueryParameters> | undefined) : Promise<OrdersKpi | undefined>;
    /**
     * Counts the active orders the organization took in the period. Despite the route's mtd segment the window is entirely the caller's: nothing is clamped to the current month, and month-to-date is simply what you get by sending the first of the month as the start date. Both bounds are inclusive and are compared against the order date as a full timestamp, so an end date sent without a time stops at midnight. Order status is not considered; only orders marked inactive drop out. A period with no orders is a success reporting zero.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<MtdRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Counts the active orders the organization took in the period. Despite the route's mtd segment the window is entirely the caller's: nothing is clamped to the current month, and month-to-date is simply what you get by sending the first of the month as the start date. Both bounds are inclusive and are compared against the order date as a full timestamp, so an end date sent without a time stops at midnight. Order status is not considered; only orders marked inactive drop out. A period with no orders is a success reporting zero.
 */
export interface MtdRequestBuilderGetQueryParameters {
    /**
     * End of the period, inclusive. Compared against the order date as a full timestamp, so adate with no time stops at midnight; it must not be earlier than the start date.
     */
    endDate?: Date;
    /**
     * Start of the period, inclusive. Send the first of the month for a month-to-date count;nothing is clamped to the current month for you.
     */
    startDate?: Date;
}
/**
 * Uri template for the request builder.
 */
export const MtdRequestBuilderUriTemplate = "{+baseurl}/api/analytics/orders/mtd?endDate={endDate}&startDate={startDate}";
/**
 * Metadata for all the requests in the request builder.
 */
export const MtdRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: MtdRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOrdersKpiFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
